export default __webpack_public_path__ + "static/media/resolucao-2017.89f26962.pdf";